export type FormattedCodeBlock = {
  code: string;
  language: 'js' | 'plainText';
};

export const formatCodeBlock = (value: unknown): FormattedCodeBlock => {
  let jsonValue = value;

  if (typeof value === 'string') {
    try {
      jsonValue = JSON.parse(value) as unknown;
    } catch {
      return { code: value, language: 'plainText' };
    }
  }

  try {
    const code = JSON.stringify(jsonValue, null, 2);
    if (code === undefined) return { code: String(jsonValue), language: 'plainText' };

    return {
      code,
      language: 'js',
    };
  } catch {
    return { code: String(jsonValue), language: 'plainText' };
  }
};
